import { render, staticRenderFns } from "./IconConsent.vue?vue&type=template&id=5f892e40&"
import script from "./IconConsent.vue?vue&type=script&lang=js&"
export * from "./IconConsent.vue?vue&type=script&lang=js&"
import style0 from "./IconConsent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports